import React, { useState, useEffect, forwardRef } from 'react'
// import PropTypes from 'prop-types'
import { Grid, Button, createMuiTheme, MuiThemeProvider } from '@material-ui/core'
import MaterialTable, { MTableToolbar } from 'material-table'
import Select from 'react-select'
import axios from 'axios'
import { get, map } from 'lodash'
import PropTypes from 'prop-types'
import { currency } from '../../../../../helpers'

// components
import JobFunctionFormDlg from './JobFunctionFormDlg'
import JobTitleFormDlg from './JobTitleFormDlg'
import JobCountryFormDlg from './JobCountryFormDlg'
import JobCityFormDlg from './JobCityFormDlg'
import CustomizedSnackbars from '../../../../../components/MessageSnacks/CustomizedSnackbars'
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { useStyles } from '../styles'



const buttonTheme = createMuiTheme({
	overrides:{
		MuiIconButton:{
			root:{
				"&:hover":{
					backgroundColor:''
				}

			}
		}
	}
})


export default function WorkforceTable(props) {

	const classes = useStyles()

	const groupsNames = {
		'E': 'Executive',
		'M': 'People Mgmt',
		'P': 'Professional IC',
		'S': 'Support IC',
	}

	const levels = {
		'E': ['6', '7', '8', '9', '10'],
		'M': ['1', '2', '3', '4', '5', '6'],
		'P': ['1', '2', '3', '4', '5', '6', '7', '8'],
		'S': ['1', '2', '3', '4', '5', '6'],
	}

	const classifications = [
		{ value: 'E', label: 'Executive' },
		{ value: 'M', label: 'People Mgmt' },
		{ value: 'P', label: 'Professional IC' },
		{ value: 'S', label: 'Support IC' },
	]

	const [selectedFunction, setSelectedFunction] = useState(null)
	const [selectedClassification, setSelectedClassification] = useState(null)
	const [selectedTitle, setSelectedTitle] = useState(null)
	const [selectedLevel, setSelectedLevel] = useState(null)
	const [selectedCountry, setSelectedCountry] = useState(null)
	const [selectedCity, setSelectedCity] = useState(null)
	const [selectedCurrency, setSelectedCurrency] = useState(null)

	const [functionSelectableValues, setFunctionSelectableValues] = useState([])
	const [classificationSelectableValues] = useState(classifications)
	const [titleSelectableValues, setTitleSelectableValues] = useState([])
	const [countrySelectableValues, setCountrySelectableValues] = useState([])
	const [citySelectableValues, setCitySelectableValues] = useState([])
	const [currencySelectableValues, setCurrencySelectableValues] = useState([])

	const [openJobFunctionForm, setOpenJobFunctionForm] = useState(false)
	const [openJobTitleForm, setOpenJobTitleForm] = useState(false)
	const [openCountryForm, setOpenCountryForm] = useState(false)
	const [openCityForm, setOpenCityForm] = useState(false)

	const [companyFunctionsDataVersion, setCompanyFunctionsDataVersion] = useState(0)
	const [companyTitlesDataVersion, setCompanyTitlesDataVersion] = useState(0)
	const [countriesDataVersion, setCountriesDataVersion] = useState(0)
	const [citiesDataVersion, setCitiesDataVersion] = useState(0)

	var [open, setOpen] = useState(false)
	var [errorMessage, setErrorMessage] = useState('')

	useEffect(() => {
		axios(`/api/company_data?perPage=10000&type=job_function`)
			.then((res) => {
				const jobFunctions = res.data.data.data.map(d => {
					return { value: d.id, label: d.name }
				})
				jobFunctions.push({value: -1, label: 'ADD NEW'})
				setFunctionSelectableValues(jobFunctions)
			})
			.catch((error) => {
				console.log(error)
			})
	}, [companyFunctionsDataVersion])

	const functionChanged = (newSelectedFunction, columnProps) => {
		if(newSelectedFunction) {
			if(newSelectedFunction.value === -1) {
				setOpenJobFunctionForm(true)
			} else {
				setSelectedFunction(newSelectedFunction)
			}
		}
	}

	const newFunctionCreated = (newFunction) => {
		setCompanyFunctionsDataVersion(companyFunctionsDataVersion+1)
		setOpenJobFunctionForm(false)
		setSelectedFunction(newFunction)
	}

	useEffect(() => {
		axios(`/api/company_data?perPage=10000&type=job_title`)
			.then((res) => {
				const jobTitles = res.data.data.data.map(d => {
					return { value: d.id, label: d.name }
				})
				jobTitles.push({value: -1, label: 'ADD NEW'})
				setTitleSelectableValues(jobTitles)
			})
			.catch((error) => {
				console.log(error)
			})
	}, [companyTitlesDataVersion])


	const titleChanged = (newSelectedTitle, _props) => {
		if(newSelectedTitle) {
			if(newSelectedTitle.value === -1) {
				setOpenJobTitleForm(true)
			} else {
				setSelectedTitle(newSelectedTitle)
			}
		}
	}

	const newTitleCreated = (newTitle) => {
		setCompanyTitlesDataVersion(companyTitlesDataVersion+1)
		setOpenJobTitleForm(false)
		setSelectedTitle(newTitle)
	}

	// get all Countries of this company
	useEffect(() => {
		axios(`/api/company_countries`)
			.then((res) => {
				const countriesData = res.data.data.map((d) => {
					return { value: d.id, label: d.name }
				})
				countriesData.push({value: -1, label: 'ADD NEW'})
				setCountrySelectableValues(countriesData)
			})
			.catch((error) => {
				console.log(error)
			})
	}, [countriesDataVersion])

	const countryChanged = (newSelectedCountry) => {
		if(newSelectedCountry) {
			if(newSelectedCountry.value === -1) {
				setOpenCountryForm(true)
			} else {
				setSelectedCountry(newSelectedCountry)
				setSelectedCity(null)
			}
		}
	}

	const newCountryCreated = (newCountry) => {
		setCountriesDataVersion(countriesDataVersion+1)
		setOpenCountryForm(false)
		setSelectedCountry(newCountry)
	}

	// get all Cities of this company for selcted country
	useEffect(() => {
		if(selectedCountry){
			axios(`/api/cities?country_id=${selectedCountry.value}`)
				.then((res) => {
					const citiesData = res.data.data.map((d) => {
						return { value: d.id, label: d.name }
					})
					citiesData.push({value: -1, label: 'ADD NEW'})
					setCitySelectableValues(citiesData)
				})
				.catch((error) => {
					console.log(error)
				})
		}
	}, [selectedCountry, citiesDataVersion])

	const cityChanged = (newSelectedCity) => {
		if(newSelectedCity) {
			if(newSelectedCity.value === -1) {
				setOpenCityForm(true)
			} else {
				setSelectedCity(newSelectedCity)
			}
		}
	}

	const newCityCreated = (newCity) => {
		setCitiesDataVersion(citiesDataVersion+1)
		setOpenCityForm(false)
		setSelectedCity(newCity)
	}

	// get all Available Currency Codes
	useEffect(() => {

		axios('/api/currency')
			.then((res) => {
				const currenciesData = res.data.data.map((d) => {
					return { label: d.full_name + ` (${d.short_code})`, value: d.short_code }
				})
				setCurrencySelectableValues(currenciesData)
			})
			.catch((error) => {
				console.log('error', error)
			})

	}, [])
	const currencyChanged = (newSelectedCurrency) => {
		if (newSelectedCurrency) {

			setSelectedCurrency(newSelectedCurrency)

		}
	}

	const getColumnColors = row => {
		return row ? {
			backgroundColor: row.duplicate ? 'red' : 'white',
			color: row.duplicate ? 'white' : 'black',
		} : null
	}
	const columns = [
		{
			title: 'Function',
			field: 'company_function.name',
			cellStyle: (colData, row) => {
				return {
					width: 200,
					...getColumnColors(row)
				}
			},
			editComponent: columnProps => {
				const functionValue = get(columnProps.rowData, 'company_function', null)
				let existingFunctionValue = null
				if(functionValue){
					existingFunctionValue = {value: functionValue.id, label: functionValue.name}
				}
				return (
					<div className={classes.functionSelect}>
						<Select
							value={selectedFunction || existingFunctionValue}
							onChange={(newSelectedFunction) => functionChanged(newSelectedFunction, columnProps)}
							options={functionSelectableValues}
							styles={classes.customStyles}
						/>
					</div>
				)
			}
		},
		{
			title: 'Title',
			field: 'company_title.name',
			cellStyle: (colData, row) => {
				return{
					width: 200,
					...getColumnColors(row)
				}
			},
			editComponent: columnProps => {
				const titleValue = get(columnProps.rowData, 'company_title', null)
				let existingTitleValue = null
				if(titleValue){
					existingTitleValue = {value: titleValue.id, label: titleValue.name}
				}
				return (
					<div className={classes.titleSelect}>
						<Select
							value={selectedTitle || existingTitleValue}
							onChange={(newSelectedTitle) => titleChanged(newSelectedTitle)}
							options={titleSelectableValues}
							styles={classes.customStyles}
						/>
					</div>
				)
			}
		},
		{
			title: 'Classification',
			field: 'job_category',
			render: rowData => {
				return groupsNames[rowData.job_category]
			},
			cellStyle: (colData, row) => {
				return{
					width: 100,
					...getColumnColors(row)
				}
			},
			editComponent: columnProps => {
				const categoryValue = get(columnProps.rowData, 'job_category', null)
				let existingCategoryValue = null
				if(categoryValue){
					existingCategoryValue = {value: categoryValue, label: groupsNames[categoryValue]}
				}

				return (
					<div className={classes.categorySelect}>
						<Select
							value={selectedClassification || existingCategoryValue}
							onChange={(newSelectedClassification) => setSelectedClassification(newSelectedClassification)}
							options={classificationSelectableValues}
							styles={classes.customStyles}
						/>
					</div>
				)
			}
		},
		{
			title: 'Job Level',
			field: 'job_level',
			cellStyle: (colData, row) => {
				return{
					width: 100,
					...getColumnColors(row)
				}
			},
			editComponent: columnProps => {
				const levelValue = get(columnProps.rowData, 'job_level', null)
				const categoryValue = get(columnProps.rowData, 'job_category', null)
				let existingLevelValue = null
				if(levelValue){
					existingLevelValue = {value: levelValue.toString(), label: levelValue.toString()}
				}
				let existingCategoryValue = null
				if(categoryValue){
					existingCategoryValue = {value: categoryValue, label: groupsNames[categoryValue]}
				}

				const existingCategory = selectedClassification || existingCategoryValue
				let levelsSelectables = []
				if(existingCategory) {
					const newLevels = levels[existingCategory.value].map(l => {
						return {value: l.toString(), label: l.toString()}
					})
					levelsSelectables = newLevels
				}

				return (
					<div className={classes.jobLevelSelect}>
						<Select
							value={selectedLevel || existingLevelValue}
							onChange={(newSelectedLevel) => setSelectedLevel(newSelectedLevel)}
							options={levelsSelectables}
							styles={classes.customStyles}
						/>
					</div>
				)
			}
		},
		{
			title: '# of Hires',
			field: 'employees_count',
			cellStyle: (colData, row) => {
				return{
					width: 100,
					...getColumnColors(row)
				}
			},
		},
		{
			title: 'Country',
			field: 'country.name',
			cellStyle: (colData, row) => {
				return{
					width: 150,
					...getColumnColors(row)
				}
			},
			editComponent: columnProps => {
				const countryValue = get(columnProps.rowData, 'country', null)
				let existingCountryValue = null
				if(countryValue){
					existingCountryValue = {value: countryValue.id, label: countryValue.name}
				}
				return (
					<div className={classes.countrySelect}>
						<Select
							value={selectedCountry || existingCountryValue}
							onChange={(newSelectedCountry) => countryChanged(newSelectedCountry)}
							options={countrySelectableValues}
							styles={classes.customStyles}
						/>
					</div>
				)
			}
		},
		{
			title: 'City',
			field: 'city.name',
			cellStyle: (colData, row) => {
				return{
					width: 150,
					...getColumnColors(row)
				}
			},
			editComponent: columnProps => {
				const cityValue = get(columnProps.rowData, 'city', null)
				let existingCityValue = null
				if(cityValue){
					existingCityValue = {value: cityValue.id, label: cityValue.name}
				}
				return (
					<div className={classes.citySelect}>
						<Select
							value={selectedCity || existingCityValue}
							onChange={(newSelectedCity) => cityChanged(newSelectedCity)}
							options={citySelectableValues}
							styles={classes.customStyles}
						/>
					</div>
				)
			}
		},
		{
			title: 'Estimated Salary',
			field: 'estimated_salary',
			render: (data) => {
				const estimateSalary = currency(data.estimated_salary, data.currency_code)
				return estimateSalary
			},
			type: 'numeric',
			cellStyle: (colData, row) => {
				return{
					width: 100,
					...getColumnColors(row)
				}
			},
		},
		{
			title: 'Currency Code',
			field: 'currency_code',
			cellStyle: (colData, row) => {
				return {
					width: 100,
					...getColumnColors(row)
				}
			},
			editComponent: columnProps => {
				const currencyValue = get(columnProps.rowData, 'currency_code', null)
				let existingCurrencyValue = null
				if (currencyValue) {
					existingCurrencyValue = { label: currencyValue, value: currencyValue }
				}
				return (
					<div className={classes.citySelect}>
						<Select
							value={selectedCurrency ? selectedCurrency : existingCurrencyValue}
							onChange={(newSelectedCurrency) => currencyChanged(newSelectedCurrency)}
							options={currencySelectableValues}
							styles={classes.customStyles}
						/>
					</div>
				)
			}
		},
		{
			title: 'Completed By',
			field: 'completed_by',
			cellStyle: (colData, row) => {
				return{
					width: 100,
					...getColumnColors(row)
				}
			},
		},
		{
			title: 'Created By',
			field: 'created.name',
			editable: 'never',
			removable: true,
			cellStyle: (colData, row) => {
				return{
					...getColumnColors(row)
				}
			},
		},
	]

	const isFormDataValid = (formData) => {
		return (selectedFunction !== null &&
			selectedTitle !== null &&
			selectedLevel !== null &&
			selectedClassification !== null &&
			selectedCountry !== null &&
			selectedCity !== null &&
			selectedCurrency.value !== null &&
			Number(get(formData, 'employees_count', '')) !== 0)
	}

	const isFormDataValidForEdit = (formData) => {
		return Number(get(formData, 'employees_count', '')) !== 0
	}

	const compileWorkforceData = (formData) => {
		return {
			company_function_id: selectedFunction.value,
			company_title_id: selectedTitle.value,
			job_level: selectedLevel.value,
			job_category: selectedClassification.value,
			country_id: selectedCountry.value,
			city_id: selectedCity.value,
			employees_count: formData.employees_count,
			forecast_id: props.selectedForecast.value,
			estimated_salary: formData.estimated_salary,
			currency_code: selectedCurrency ? selectedCurrency.value : formData.currency_code,
			completed_by: formData.completed_by,
		}
	}

	const compileWorkforceDataForEdit = (formData) => {
		return {
			company_function_id: selectedFunction ? selectedFunction.value : formData.company_function.id,
			company_title_id: selectedTitle ? selectedTitle.value : formData.company_title.id,
			job_level: selectedLevel ? selectedLevel.value : formData.job_level.toString(),
			job_category: selectedClassification ? selectedClassification.value : formData.job_category,
			country_id: selectedCountry ? selectedCountry.value : formData.country.id,
			city_id: selectedCity ? selectedCity.value : formData.city.id,
			employees_count: formData.employees_count,
			forecast_id: props.selectedForecast.value,
			estimated_salary: formData.estimated_salary,
			currency_code: selectedCurrency ? selectedCurrency.value : formData.currency_code,
			completed_by: formData.completed_by,
		}
	}

	const clearFormState = () => {
		setSelectedFunction(null)
		setSelectedClassification(null)
		setSelectedTitle(null)
		setSelectedLevel(null)
		setSelectedCountry(null)
		setSelectedCity(null)
		setSelectedCurrency(null)
	}

	const handleClose = () => {
		setOpen(false)
	}

	return (
		<>
			<div className={classes.workForceTable}>
				<CustomizedSnackbars
					open={open}
					handleClose={handleClose}
					variant={'error'}
					message={errorMessage}
				/>
				<MuiThemeProvider theme={buttonTheme}>
					<MaterialTable
						title={`Add Workforce To ${get(props, 'selectedForecast.label', '________')}`}
						columns={columns}
						data={props.data}
						icons={{
							Add: forwardRef((props, ref) => (
								<div style={{
									padding: '10px 20px',
									border: 'none',
									borderRadius: '4px',
									background: '#1890ff',
									color: '#fff',
									fontSize: '14px',
									cursor: 'pointer',
									transition: '.3s background',
									'&:hover': {
										background: '#40a9ff'
									}}}
								>
									Add New Entry In Workforce
								</div>
							))
						}}
						options={{
							pageSize: 10,
							search: false,
							addRowPosition: 'first',
							maxBodyHeight: '600px',
							headerStyle: {
								backgroundColor: '#D8E4E4',
								color: 'black',
								borderRight: '1px solid #d6cbcb',
								position: 'sticky',
								top: 0,
								whiteSpace: 'nowrap',
							},
						}}
						localization={{
							body: {
								addTooltip: 'Add New WorkForce Entry'
							},
						}}
						components={{
							Toolbar: toolBarProps => (
								<>
									<MTableToolbar {...toolBarProps} />
									<Grid container direction='row' justify='flex-end' alignItems='center'>
										<Grid item>
											<Button onClick={props.onDownloadTemplate} className={classes.lowercaseBtn} color="primary">Download Workforce Template</Button>
										</Grid>
										<Grid item>
											<Button onClick={props.onUploadTemplate} className={classes.lowercaseBtn} color="primary">Upload Workforce Template</Button>
										</Grid>
										<Grid item>
											<Button onClick={props.onDownloadData} className={classes.lowercaseBtn} color="primary">Download Workforce Data</Button>
										</Grid>
									</Grid>
								</>
							)
						}}
						editable={{
							onRowAdd: newData =>
								new Promise(async (resolve, reject) => {
									if(isFormDataValid(newData)){
										const formData = compileWorkforceData(newData)
										await props.createWorkforce(formData)
										clearFormState()
										resolve()
									} else {
										setOpen(true)
										setErrorMessage('Please fill all fields')
										reject()
									}
								}),
							onRowUpdate: (worforceData, oldData) =>
								new Promise(async (resolve, reject) => {
									if(isFormDataValidForEdit(worforceData)){
										const formData = compileWorkforceDataForEdit(worforceData)
										formData.id = worforceData.id
										await props.updateWorkforce(formData)
										clearFormState()
										resolve()
									} else {
										setOpen(true)
										setErrorMessage('Please fill all fields')
										reject()
									}
								}),
							onRowDelete: workforce =>
								new Promise(async (resolve, reject) => {
									const status = await props.deleteWorkforce(workforce.id)
									if(status) {
										resolve()
									} else {
										setOpen(true)
										setErrorMessage('deletion failed')
										reject()
									}
								}),
						}}
						actions = {[
							{
								icon: FileCopyIcon,
								tooltip: 'copy row',
								onClick: (event, rowData) => {
									rowData.job_level = rowData.job_level.toString()
									props.createWorkforce(rowData)
									clearFormState()
								}
							}
						]}
					/>
				</MuiThemeProvider>
			</div>

			{
				openJobFunctionForm ?
					<JobFunctionFormDlg
						isOpen={openJobFunctionForm}
						onClose={() => {setOpenJobFunctionForm(false)}}
						onSuccess={(value) => newFunctionCreated(value)}
					/>
					:
					null
			}

			{
				openJobTitleForm ?
					<JobTitleFormDlg
						isOpen={openJobTitleForm}
						onClose={() => {setOpenJobTitleForm(false)}}
						onSuccess={(value) => newTitleCreated(value)}
					/>
					:
					null
			}

			{
				openCountryForm ?
					<JobCountryFormDlg
						isOpen={openCountryForm}
						onClose={() => {setOpenCountryForm(false)}}
						onSuccess={(value) => newCountryCreated(value)}
					/>
					:
					null
			}

			{
				(openCityForm && selectedCountry) ?
					<JobCityFormDlg
						isOpen={openCityForm}
						country={selectedCountry}
						onClose={() => {setOpenCityForm(false)}}
						onSuccess={(value) => newCityCreated(value)}
					/>
					:
					null
			}

		</>
	)
}

WorkforceTable.propTypes = {
	data: PropTypes.array.isRequired,
	masterData: PropTypes.object.isRequired,
	selectedForecast: PropTypes.object.isRequired,
	onUploadTemplate: PropTypes.func.isRequired,
	onDownloadTemplate: PropTypes.func.isRequired,
	onDownloadData: PropTypes.func.isRequired,
	createWorkforce: PropTypes.func.isRequired,
	updateWorkforce: PropTypes.func.isRequired,
	deleteWorkforce: PropTypes.func.isRequired,
}
